<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <h3>درآمدهای من</h3>
                </v-flex>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="Name"
                                    select-all
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ toPersianDigit(props.item.basket_id,false) }}</td>
                                    <td class="text-xs-center">{{ props.item.art_name }}</td>
                                    <td class="text-xs-center">{{ props.item.blank_name }}</td>
                                    <td class="text-xs-center">{{ props.item.shop_name }}</td>
                                    <td class="text-xs-center" style="direction: ltr">{{ toJalali(props.item.created_at) }}</td>

                                    <td class="text-xs-center">{{ toPersianDigit(props.item.quantity,false) }}</td>
                                    <td class="text-xs-center">{{ toPersianDigit(props.item.commission,false) }}</td>
                                    <td class="text-xs-center">{{ moneyFormat(props.item.total_commission) }}</td>
                                    <td class="text-xs-center">{{ props.item.refinance_status }}</td>


                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'شماره خرید',
            value: 'basket_id',
            align: 'center'
          },
          {
            text: 'عنوان طرح',
            value: 'art_name',
            align: 'center'
          },
          {
            text: 'نوع محصول',
            value: 'blank_name',
            align: 'center'
          },
          {
            text: 'فروشگاه',
            value: 'shop_name',
            align: 'center'
          },
          {
            text: 'تاریخ سفارش',
            value: 'created_at',
            align: 'center'
          },
          {
            text: 'تعداد',
            value: 'quantity',
            align: 'center'
          },
          {
            text: 'سود فروش هر واحد',
            value: 'commission',
            align: 'center'
          },
          {
            text: 'مجموع (﷼)',
            value: 'total_commission',
            align: 'center'
          },
          {
            text: 'وضعیت تسویه',
            value: 'refinance_status',
            align: 'center'
          },
        ],
        items: []
      }
    };
  },
  created: function () {
    this.axios.get('/reseller/commissions/')
      .then(response => {
        this.complex.items = response.data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/commission/history.vue